import axios from 'axios';

export default () => {
    return {
        staff: [],
        selectedPerson: {
            id: '',
            name: '',
            picture: '',
            jobTitle: '',
            department: '',
            phone: '',
            phoneLink: '',
            email: '',
            emailLink: '',
            birthday: '',
            supervisor: '',
            supervisor_handle: ''
        },
        personSelected: false,
        search: '',
        results: false,
        searchStarted: false,
        profileCover: false,
        supervisorResults: true,
        filters: {
            ministries: [
                {
                    title: 'All Ministries',
                    slug: 'all',
                    active: true
                },
                {
                    title: 'Business Services',
                    slug: 'biz_services',
                    active: false
                },
                {
                    title: 'Camps',
                    slug: 'camps',
                    active: false
                },
                {
                    title: 'College',
                    slug: 'college',
                    active: false
                },
                {
                    title: 'Guest Experience',
                    slug: 'guest_exp',
                    active: false
                },
                {
                    title: 'Homes',
                    slug: 'homes',
                    active: false
                },
                {
                    title: 'Leader Dev',
                    slug: 'leader_dev',
                    active: false
                },
                {
                    title: 'Marketing',
                    slug: 'marketing',
                    active: false
                },
                {
                    title: 'Marriage',
                    slug: 'marriage',
                    active: false
                },
                {
                    title: 'Teams',
                    slug: 'teams',
                    active: false
                }
            ]
        },

        init() {
            gsap.set(this.$refs.gridCover, { autoAlpha: 0 });
            gsap.set(this.$refs.staffGrid, { height: 180 });
            // this.fetchStaff();
        },

        closeProfile() {
            this.personSelected = false;
            this.supervisorResults = true;
            this.profileCover = false;
        },

        openGrid() {
            const open = gsap.timeline();

            open.to(this.$refs.staffGrid, {
                duration: 0.7,
                height: this.$refs.staffGrid.scrollHeight,
                ease: 'power2.inOut'
            }).to(this.$refs.gridCover, { duration: 0.3, autoAlpha: 0 }, '<0.3');
        },

        closeGrid() {
            const close = gsap.timeline();
            close
                .to(this.$refs.gridCover, { duration: 0.3, autoAlpha: 1 })
                .to(this.$refs.staffGrid, { duration: 0.6, height: 180, ease: 'power2.inOut' }, '<0');
        },

        fetchStaff() {
            this.searchStarted = true;
            this.results = true;
            this.closeGrid();
            const requestData = new FormData();
            requestData.append('action', 'fetch_staff');

            this.filters.ministries.forEach(filter => {
                if (filter.slug !== 'all' && filter.active) {
                    requestData.append(filter.slug, filter.slug);
                }
            });

            requestData.append('search_term', this.search);

            axios
                .post(winshape.ajaxurl, requestData)
                .then(response => {
                    this.staff = [];

                    if (response.data != '') {
                        response.data.forEach(person => {
                            let staffMember = {
                                id: person.handle,
                                name: person.name,
                                department: person.department,
                                jobTitle: person.job_title,
                                picture: person.picture,
                                phone: person.phone,
                                phoneLink: `tel:${person.phone}`,
                                email: person.email,
                                emailLink: `mailto:${person.email}`,
                                birthday: person.birthday,
                                supervisor: person.supervisor,
                                supervisor_handle: person.supervisor_handle
                            };

                            this.staff.push(staffMember);
                        });
                    } else {
                        this.results = false;
                    }

                    setTimeout(() => {
                        this.openGrid();
                    }, 600);
                })
                .catch(error => {
                    console.log(error);
                });
        },

        fetchSupervisor() {
            this.profileCover = true;
            this.supervisorResults = true;

            const requestData = new FormData();
            requestData.append('action', 'fetch_supervisor');
            requestData.append('supervisor_id', this.selectedPerson.supervisor_handle);

            axios
                .post(winshape.ajaxurl, requestData)
                .then(response => {
                    if (response.data != '') {
                        let person = response.data[0];

                        this.selectedPerson = {
                            id: person.handle,
                            name: person.name,
                            department: person.department,
                            jobTitle: person.job_title,
                            picture: person.picture,
                            phone: person.phone,
                            phoneLink: `tel:${person.phone}`,
                            email: person.email,
                            emailLink: `mailto:${person.email}`,
                            birthday: person.birthday,
                            supervisor: person.supervisor,
                            supervisor_handle: person.supervisor_handle
                        };
                    } else {
                        setTimeout(() => {
                            this.supervisorResults = false;
                        }, 600);
                    }

                    setTimeout(() => {
                        this.profileCover = false;
                    }, 600);
                })
                .catch(error => {
                    console.log(error);
                });
        }
    };
};
